import { render, staticRenderFns } from "./TaskAdminListOrderPop.vue?vue&type=template&id=3d6bd9a5&"
import script from "./TaskAdminListOrderPop.vue?vue&type=script&lang=js&"
export * from "./TaskAdminListOrderPop.vue?vue&type=script&lang=js&"
import style0 from "./TaskAdminListOrderPop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports